export class CredentialsReadError extends Error {}
